<template>
  <div
    class="flex flex-row gap-2 b1 p-2 rounded bg-white"
  >
    <span
      class="aspect-square rounded-full h-[1em] my-auto"
      :class="{
        'bg-danger': status === 'banned',
        'bg-black': status === 'offline' || status === 'unknown',
        'bg-warning': status === 'muted',
        'bg-success': status === 'online',
      }"
    />
    <span
      class="text-black"
    >
      {{ t('jc.component.userStatus.' + status) }}
    </span>
  </div>
</template>

<script setup lang="ts">
import type { User } from '~/composables/charon'

const { t } = useI18n()

const props = defineProps<{
  user: User | null
}>()

const status = computed(() => {
  if (!props.user) {
    return 'unknown'
  }
  if (props.user.banned) {
    return 'banned'
  }
  if (!props.user.online) {
    return 'offline'
  }
  if (props.user.muted) {
    return 'muted'
  }
  return 'online'
})
</script>
